<template>
  <div class="breadcrumbs__container">
    <q-breadcrumbs
      :gutter="isSample ? 'none' : 'sm'"
      class="q-py-sm q-px-md breadcrumbs__container"
    >
      <template v-slot:separator>
        <q-icon size="1.5em" name="chevron_right" color="white"></q-icon>
      </template>
      <q-breadcrumbs-el
        :class="{ 'font--small': isSample }"
        style="cursor: pointer; color: #fff"
        @click="backtoProjects"
      >
        {{ $t("sidebar.projects") }}</q-breadcrumbs-el
      >
      <q-breadcrumbs-el
        :class="{ 'font--small': isSample }"
        @click="backToProjectPage"
        style="cursor: pointer; color: #fff"
        >{{ isSample ? projectName : `ID ${projectName}` }}</q-breadcrumbs-el
      >
      <q-breadcrumbs-el
        :class="{ 'font--small': isSample }"
        :label="$t('sidebar.3dmodel')"
        style="color: #fff; font-weight: 700"
      />
    </q-breadcrumbs>
  </div>
</template>

<script setup>
import { authService } from "@/services/authService.js";

const props = defineProps(["projectId", "projectName", "isSample"]);

function backToProjectPage() {
  window.location.href = `${window.runtimeConfig?.AFP_URL}/project/${props.projectId}?login_hint=${authService.userEmail}`;
}
function backtoProjects() {
  window.location.href = `${window.runtimeConfig?.AFP_URL}/project/list?login_hint=${authService.userEmail}`;
}
</script>

<style scoped>
.font--small {
  font-size: 10px;
}
</style>
